import api from './api';

export interface EmailConfig {
  host: string;
  port: number;
  secure: boolean;
  auth: {
    user: string;
    pass: string;
  };
  fromEmail: string;
  fromName?: string;
}

export interface Company {
  id: string;
  name: string;
  location?: string;
  companyType?: string;
  numberOfEmployees: number;
  logoUrl?: string;
  baseCurrency?: string;
  openingBalance?: number;
  enableNonBillableTime?: boolean;
  nonBillableCategories?: string[];
  emailConfig?: EmailConfig;
  // Bank Account Details (UK)
  bankAccountName?: string;
  bankAccountNumber?: string;
  bankSortCode?: string;
  // International Bank Details
  bankCurrencyAccepted?: string;
  bankIban?: string;
  bankBic?: string;
  // Contact Details
  contactPhone?: string;
  contactEmail?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCompanyData {
  name: string;
  location?: string;
  companyType?: string;
  numberOfEmployees: number;
}

export interface UpdateCompanyData {
  name?: string;
  location?: string;
  companyType?: string;
  numberOfEmployees?: number;
  logoUrl?: string;
  baseCurrency?: string;
  openingBalance?: number;
  enableNonBillableTime?: boolean;
  nonBillableCategories?: string[];
  emailConfig?: EmailConfig;
  // Bank Account Details (UK)
  bankAccountName?: string;
  bankAccountNumber?: string;
  bankSortCode?: string;
  // International Bank Details
  bankCurrencyAccepted?: string;
  bankIban?: string;
  bankBic?: string;
  // Contact Details
  contactPhone?: string;
  contactEmail?: string;
}

export const companiesApi = {
  getById: async (id: string): Promise<Company> => {
    const response = await api.get(`/companies/${id}`);
    return response.data.data;
  },

  update: async (id: string, data: UpdateCompanyData): Promise<Company> => {
    const response = await api.put(`/companies/${id}`, data);
    return response.data.data;
  },

  uploadLogo: async (id: string, file: File): Promise<Company> => {
    const formData = new FormData();
    formData.append('logo', file);
    // Don't set Content-Type header - let browser set it with boundary for multipart/form-data
    const response = await api.post(`/companies/${id}/logo`, formData);
    return response.data.data;
  },
};






